Object.defineProperty(exports, "__esModule", { value: true });
exports.avonDarkColorTokens = exports.avonLightColorTokens = void 0;
var avon_light_1 = require("./avon-light");
Object.defineProperty(exports, "avonLightColorTokens", { enumerable: true, get: function () { return avon_light_1.avonLightColorTokens; } });
var avon_dark_1 = require("./avon-dark");
Object.defineProperty(exports, "avonDarkColorTokens", { enumerable: true, get: function () { return avon_dark_1.avonDarkColorTokens; } });
//# sourceMappingURL=index.js.map